import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=437711eb&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=437711eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437711eb",
  null
  
)

export default component.exports